import React from 'react';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';
import './css/FixedContact.css';
const FixedContact = () => {
    const phoneNumber = "+919814562530"; 
    
    const handleCall = () => {
        window.location.href = `tel:${phoneNumber}`;
    };

    const handleWhatsApp = () => {
        window.location.href = `https://wa.me/${phoneNumber}`;
    };

    return (
        <div className="fixed-contact-wrapper">
            <div className="contact-circle whatsapp" onClick={handleWhatsApp} data-tooltip="Connect on WhatsApp">
                <FaWhatsapp size={24} />
            </div>
            <div className="contact-circle call" onClick={handleCall} data-tooltip="Direct Call">
                <FaPhone size={24} />
            </div>
        </div>
    );
};

export default FixedContact;
